import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const cx = (...parts) => parts.filter(Boolean).join(' ');

/** International phone input using global `.app-field` and `.react-tel-input` theme tokens. */
function AppPhoneField({ containerClass, inputClass, buttonClass, ...rest }) {
  return (
    <PhoneInput
      containerClass={cx('!w-full', containerClass)}
      inputClass={cx('!w-full app-field', inputClass)}
      buttonClass={cx('!border-r-0', buttonClass)}
      {...rest}
    />
  );
}

export default AppPhoneField;
